import { useMemo } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { TrainingSessionsTab } from '../../components/plans/TrainingSessionsTab';
import { TrainingCyclesTab } from '../../components/plans/TrainingCyclesTab';

const TAB_INDEX_BY_NAME: Record<string, number> = {
  sessions: 0,
  cycles: 1
};

export default function PlansPage() {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();

  // ?tab=sessions|cycles permite que un link/checklist abra directamente el tab deseado.
  const activeIndex = useMemo<number>(() => {
    const requested = searchParams.get('tab');
    if (requested && requested in TAB_INDEX_BY_NAME) {
      const idx = TAB_INDEX_BY_NAME[requested];
      return typeof idx === 'number' ? idx : 0;
    }
    return 0;
  }, [searchParams]);

  const handleTabChange = (index: number): void => {
    const name = Object.keys(TAB_INDEX_BY_NAME).find((k) => TAB_INDEX_BY_NAME[k] === index);
    if (!name) return;
    const next = new URLSearchParams(searchParams);
    next.set('tab', name);
    setSearchParams(next, { replace: true });
  };

  return (
    <div
      style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0.75rem',
        width: '100%'
      }}
    >
      <TabView className="ios-plans-tabs" activeIndex={activeIndex} onTabChange={(e) => handleTabChange(e.index)}>
        <TabPanel header={intl.formatMessage({ id: 'coach.sections.trainingSessions' })}>
          <TrainingSessionsTab />
        </TabPanel>
        <TabPanel header={intl.formatMessage({ id: 'coach.sections.trainingCycles' })}>
          <TrainingCyclesTab />
        </TabPanel>
      </TabView>
    </div>
  );
}
